import { t } from '../lib/i18n.js';
import { AUDIO_SPEEDS, type AudioSpeed } from '../lib/audio-speed.js';
import './AudioSpeed.css';

interface AudioSpeedProps {
  value: number;
  onChange: (speed: AudioSpeed) => void;
  disabled?: boolean;
}

const speedLabel = (speed: AudioSpeed) =>
  speed === 0.8 ? t('Slow', 'ゆっくり') : speed === 1 ? t('Standard', '標準') : t('Faster', '速め');

export function AudioSpeed({ value, onChange, disabled = false }: AudioSpeedProps) {
  const custom = !AUDIO_SPEEDS.some((speed) => speed === value);
  return (
    <fieldset className="audio-speed" disabled={disabled}>
      <legend>{t('Speech speed', '読み上げ速度')}</legend>
      <div className="audio-speed__options">
        {AUDIO_SPEEDS.map((speed) => (
          <label key={speed}>
            <input
              type="radio"
              name="audio-speed"
              value={speed}
              checked={value === speed}
              onChange={() => onChange(speed)}
            />
            <span>
              <b>{speedLabel(speed)}</b>
              <small>{speed}×</small>
            </span>
          </label>
        ))}
      </div>
      {custom && (
        <small className="audio-speed__custom">
          {t(`Current room setting: ${value}×. Choose a preset to change it.`, `現在のルーム設定: ${value}×。変更する場合は上から選んでください。`)}
        </small>
      )}
    </fieldset>
  );
}
